// Pure helpers for the chat UI (no React), so they can be unit-tested.

const TOOL_KIND = {
  Bash: 'terminal', Read: 'file', Edit: 'edit', MultiEdit: 'edit', Write: 'edit', NotebookEdit: 'edit',
  Grep: 'search', Glob: 'search', WebFetch: 'web', WebSearch: 'web', Task: 'agent', Agent: 'agent',
};
const VERB = { terminal: 'Ran', file: 'Read', edit: 'Edited', search: 'Searched', web: 'Fetched', agent: 'Delegated', other: 'Used' };
const VERB_ACTIVE = { terminal: 'Running', file: 'Reading', edit: 'Editing', search: 'Searching', web: 'Fetching', agent: 'Delegating', other: 'Using' };

export function truncate(s, max = 80) {
  const t = String(s == null ? '' : s).replace(/\s+/g, ' ').trim();
  return t.length > max ? `${t.slice(0, max - 1)}…` : t;
}

// kind picks the icon; label is the short text shown on the chip.
export function toolMeta(name, input, done = true) {
  const kind = TOOL_KIND[name] || 'other';
  const inp = input && typeof input === 'object' ? input : {};
  const target = inp.command || inp.file_path || inp.path || inp.notebook_path || inp.pattern || inp.url || inp.query || inp.description || '';
  const verb = (done ? VERB : VERB_ACTIVE)[kind];
  const subject = target ? truncate(target) : (kind === 'other' ? String(name || 'tool') : '');
  return { kind, verb, target: subject, label: subject ? `${verb} ${subject}` : verb };
}

// The full input of a tool call as readable text (the chip label is truncated to one line).
export function toolInputText(input, max = 4000) {
  if (input == null || typeof input !== 'object') return '';
  const text = typeof input.command === 'string' ? input.command : JSON.stringify(input, null, 2);
  return text.length > max ? `${text.slice(0, max)}\n… (${text.length - max} more characters)` : text;
}

// Label for what Claude is doing right now: the newest unfinished tool call, else null.
export function currentActivity(items) {
  for (let i = items.length - 1; i >= 0; i -= 1) {
    const it = items[i];
    if (it.kind === 'tool' && !it.done) return toolMeta(it.name, it.input, false).label;
    if (it.kind === 'approval' && it.status === 'pending') return 'Waiting for your approval';
  }
  return null;
}

const APPROVAL_TITLE = {
  Bash: 'Claude wants to run a command', Edit: 'Claude wants to edit a file', MultiEdit: 'Claude wants to edit a file',
  Write: 'Claude wants to write a file', NotebookEdit: 'Claude wants to edit a notebook', Read: 'Claude wants to read a file',
  WebFetch: 'Claude wants to fetch a web page', WebSearch: 'Claude wants to search the web',
};
export const approvalTitle = (toolName) => APPROVAL_TITLE[toolName] || `Claude wants to use ${toolName || 'a tool'}`;

// "just now", "5 min ago", "3 h ago", "2 d ago", else a short date.
export function relativeTime(value, now = Date.now()) {
  const t = value instanceof Date ? value.getTime() : new Date(value).getTime();
  if (!Number.isFinite(t)) return '';
  const s = Math.max(0, Math.round((now - t) / 1000));
  if (s < 45) return 'just now';
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.round(s / 3600);
  if (h < 24) return `${h} h ago`;
  const d = Math.round(s / 86400);
  if (d < 7) return `${d} d ago`;
  return new Date(t).toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
}

// True when the scroll box is within `slack` px of its bottom.
export const isNearBottom = (el, slack = 80) => !el || el.scrollHeight - el.scrollTop - el.clientHeight <= slack;

export const SUGGESTIONS = [
  'Check pm2 status of all apps',
  'Show the last 20 lines of the CRM error log',
  'What changed in angel-isp in the last commit?',
  'List large files in /home/angel/projects',
];

// First user message becomes the label when a chat has no title yet.
export const sessionLabel = (s) => (s && s.title) || 'New chat';
